export const INTERACTIVE_API_URLS = {
    INTERACTIVE_CLASSROOMS: '/api/v1/classrooms',
    TEACHING_UNIT: '/api/v1/teachingUnit',
    TEACHING_UNIT_EDIT: '/api/v1/teachingUnit/:unitId/edit',
    TEACHING_UNITS: '/api/v1/teachingUnits',
    TEACHER: '/api/v1/teacher',
};

export const INTERACTIVE_HOST = process.env.REACT_APP_INTERACTIVE_URL;
